// src/hooks/useLangNavigate.js
import { useNavigate } from 'react-router-dom';
import { useLanguageLink } from './useLanguageLink';
import { useCallback } from 'react';

export const useLangNavigate = () => {
  const navigate = useNavigate();
  const { langLink } = useLanguageLink();

  const langNavigate = useCallback(
    (path, options) => {
      navigate(langLink(path), options);
    },
    [navigate, langLink] // solo cambia si cambia el navegador o la función langLink
  );

  return langNavigate;
};
